var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",class:{ 'container--hidden': _vm.$store.getters.isPageLoaded }},[_c('div',{staticClass:"wrapper"},[_c('span',{staticClass:"span"},[_vm._v(" "+_vm._s(_vm.$store.state.loaderProgress)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }